import { InMemoryStore } from './InMemoryStore';

// eslint-disable-next-line import/no-anonymous-default-export
const inmemorystorage: InMemoryStore = new InMemoryStore();

// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export default inmemorystorage;
